
import React, { useEffect, useState } from 'react'
import { CustomHeading } from 'components'
import { Images, casinoData } from 'constants'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { svgs } from 'constants'

const AllCasino = () => {
    const initialItemsToShow = 12;
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const type = queryParams.get('type')

    const [showMoreVirtual, setShowMoreVirtual] = useState(false)
    const [showMoreLive, setShowMoreLive] = useState(false)

    const liveCasino = casinoData.find(cat => cat.category_name.trim() === 'Live Casino');
    const virtualCasino = casinoData.find(cat => cat.category_name.trim() === 'Virtual Casino');

    const displayedLiveCasino = showMoreLive ? liveCasino.data : _.take(liveCasino.data, initialItemsToShow);
    const displayedVirtualCasino = showMoreVirtual ? virtualCasino.data : _.take(virtualCasino.data, initialItemsToShow);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div>
            {type == 1 &&
                <div className="p-1 flex justify-center items-center">
                    <div>
                        <CustomHeading
                            svg={false}
                            text="Live Casino"
                            down_icon={true}
                            redirect={false}
                            type={1}
                        />

                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2 mx-1">
                            {displayedLiveCasino.map((item, index) => (
                                <div key={index}
                                    className="rounded-lg w-full h-[100px] overflow-hidden shadow-md mx-auto"
                                >
                                    <img
                                        src={item.url_thumb}
                                        alt={`${item.game_name} Thumbnail`}
                                        className="w-full h-full object- rounded-lg"
                                    />
                                </div>
                            ))}
                        </div>

                        <div className='flex justify-center items-center my-3'>
                            <button className='flex justify-center show_more_btn' onClick={() => setShowMoreLive(!showMoreLive)}>
                                <span className='mr-1'>{showMoreLive ? 'Close' : 'Show More'}</span>
                                {!showMoreLive ? svgs.plus : svgs.minus}

                            </button>
                        </div>
                    </div>
                </div>}

            {type == 2 && <div className="p-1 flex justify-center items-center">
                <div>
                    <CustomHeading
                        svg={false}
                        text="Virtual Casino"
                        down_icon={true}
                        redirect={false}
                        type={1}
                    />

                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mt-2 mx-1">
                        {displayedVirtualCasino.map((item, index) => (
                            <div key={index}
                                className="rounded-lg w-full h-[100px] overflow-hidden shadow-md mx-auto"
                            >
                                <img
                                    src={item.url_thumb}
                                    alt={`${item.game_name} Thumbnail`}
                                    className="w-full h-full object- rounded-lg"
                                />
                            </div>
                        ))}
                    </div>
                    <div className='flex justify-center items-center my-3'>
                        <button className='flex justify-center show_more_btn' onClick={() => setShowMoreVirtual(!showMoreVirtual)}>
                            <span className='mr-1'>{showMoreVirtual ? 'Close' : 'Show More'}</span>
                            {!showMoreVirtual ? svgs.plus : svgs.minus}

                        </button>
                    </div>
                </div>
            </div>}
        </div>
    )
}

export default AllCasino
